import React from "react";
import "./why-choose-us.css";
import Common_title from "../../common-components/common-title/Common_title";

const Why_choose_us = () => {
  return (
    <>
      <section className="Why_choose_us_sec">
        <div className="container-lg">
          <Common_title
            title="WHY CHOOSE US?"
            subtitle="Few reasons for people choosing"
            logo={
              process.env.PUBLIC_URL + "/assets/images/logo/geecart_logo.png"
            }
          />

          <div className="row mt-md-5 mt-3">
            <div className="col-xl-10 mx-auto">
              <div className="row">
                <div className="col-md-4 my-auto">
                  <div className="whychoosebox">
                    <div className="nodiv">
                      <p className="no">1</p>
                    </div>
                    <div className="contdiv">
                      <h5>Curated Top Brands</h5>
                      <p className="text">
                        From the latest fashion and footwear to smart
                        electronics and luxury timepieces, we bring you 100%
                        authentic products from trusted global brands.
                      </p>{" "}
                    </div>
                  </div>
                  <div className="whychoosebox">
                    <div className="nodiv">
                      <p className="no">2</p>
                    </div>
                    <div className="contdiv">
                      <h5>Unbeatable Value & Deals</h5>
                      <p className="text">
                        Enjoy transparent pricing, daily discounts, and
                        exclusive offers across all categories without
                        compromising on premium quality.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-md-4 mb-md-0 mb-4">
                  <div className="img-div">
                    <img
                      className="mobile-mockup"
                      src={
                        process.env.PUBLIC_URL +
                        "/assets/images/home/why_choose/im1.png"
                      }
                      alt="mobile-mockup"
                    />
                  </div>
                </div>
                <div className="col-md-4 my-auto">
                  <div className="whychoosebox">
                    <div className="nodiv">
                      <p className="no">3</p>
                    </div>
                    <div className="contdiv">
                      <h5>Seamless Shopping Experience</h5>
                      <p className="text">
                        Shop effortlessly with easy navigation, instant search
                        matching, secure checkout options, and fast doorstep
                        delivery.
                      </p>
                    </div>
                  </div>
                  <div className="whychoosebox">
                    <div className="nodiv">
                      <p className="no">4</p>
                    </div>
                    <div className="contdiv">
                      <h5>Hassle-Free Returns</h5>
                      <p className="text">
                        Shop with complete confidence. Enjoy smooth exchanges,
                        quick refunds, and dedicated customer support whenever
                        you need assistance.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Why_choose_us;
